<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="600">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Função
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Nome da Função*"
                  counter="40"
                  maxlength="40"
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 40)]"
                ></v-text-field>
                <v-select
                  v-model="content.tipo"
                  label="Tipo da Função*"
                  dense
                  outlined
                  item-value="id"
                  item-text="descricao"
                  :items="tipos"
                  :rules="[(v) => $required(v)]"
                  return-object
                ></v-select>
                <v-textarea
                  v-model="content.descricao"
                  label="Atividades Desempenhadas"
                  maxlength="250"
                  counter="250"
                  dense
                  outlined
                  rows="4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          actionText="Salvar"
          @click="salvar()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Funcao } from '~/commons/classes/funcao';
import { DialogProps } from '~/commons/classes/dialog-props';
import ManterFuncaoService from '@/services/manter-funcao.service';

export default {
  props: {
    ...new DialogProps(Funcao),
    tipos: {
      type: Array,
      default: () => []
    }
  },
  mixins: [ManterFuncaoService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = new Funcao(this.content).format();
          return this.edit
            ? this.$editarFuncao(this.content.id, payload)
            : this.$cadastrarFuncao(payload);
        });
      };

      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    }
  }
}
</script>